import { Bracket } from "@portal-frontend-ssr/blast-api";
import { isMatchCompleted } from "~/shared/helpers/tournaments/isMatchCompleted";
import { TournamentTeamSlot } from "@portal-frontend-ssr/blast-api";

export const mapBracketsToStandings = (brackets: Bracket[], teams: TournamentTeamSlot[]) => {
  const initialTeamsWithBounties = teams.map((team) => ({
    id: team.team?.id,
    name: team.team?.name,
    shortName: team.team?.shortName,
    bountyValue: team.metadata?.bountyValue ?? 0,
    bountySeed: team.metadata?.seed ?? undefined,
    banked: 0,
    eliminated: false,
  }));

  brackets.forEach((bracket) => {
    if (!bracket.matches) return initialTeamsWithBounties;
    bracket.matches.forEach((match) => {
      const completed = isMatchCompleted(match);
      const winnerTeamId = completed
        ? match.teamAScore > match.teamBScore
          ? match.teamA?.uuid
          : match.teamB?.uuid
        : undefined;
      const loserTeamId = winnerTeamId === match.teamA?.uuid ? match.teamB?.uuid : match.teamA?.uuid;
      const wagerAmount = match.metadata?._t === "bounty_match" ? (match.metadata?.wager ?? undefined) : undefined;

      const winner = initialTeamsWithBounties.find((t) => t.id === winnerTeamId);
      const loser = initialTeamsWithBounties.find((t) => t.id === loserTeamId);
      if (!winner || !loser) return;

      const winnerBounty = !!wagerAmount && wagerAmount > 0 ? winner.bountyValue + wagerAmount : winner.bountyValue;
      const loserBounty = !!wagerAmount && wagerAmount > 0 ? loser.bountyValue + wagerAmount : loser.bountyValue;

      // "Steal" seed if smaller
      winner.bountySeed = Math.min(winner.bountySeed ?? -1, loser.bountySeed ?? -1);
      loser.bountySeed = undefined;

      if (match.name.toUpperCase() === "FINAL") {
        // The winner takes all at the last match
        winner.banked += winnerBounty + loser.bountyValue;
        winner.bountyValue = 0;
      } else {
        // 50% logic
        winner.bountyValue += loserBounty * 0.5;
        winner.banked += loserBounty * 0.5;
      }

      // Subtract wager from loser's bank
      loser.banked = !!wagerAmount && wagerAmount > 0 ? loser.banked - wagerAmount : loser.banked;
      loser.eliminated = true;
      loser.bountyValue = 0;
    });
  });

  return initialTeamsWithBounties.sort((a, b) => {
    if (a.eliminated && !b.eliminated) return 1;
    if (!a.eliminated && b.eliminated) return -1;

    if (a.bountySeed !== undefined && b.bountySeed !== undefined) {
      return a.bountySeed - b.bountySeed;
    }

    if (b.bountyValue !== a.bountyValue) {
      return b.bountyValue - a.bountyValue;
    }

    if (b.banked !== a.banked) {
      return b.banked - a.banked;
    }

    return 0;
  });
};
